// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import FastClick from 'fastclick'
import router from './router/index'
import RouterGuide from './router/guide'
import plugin from '@/plugin/index'
import store from './store/index'
import * as filters from './filters/'
import './assets/css/reset.css'
import './assets/js/flexible.js'
import './filters/index.js'
import './assets/css/animate.css'
import { sync } from 'vuex-router-sync'
import 'vue2-animate/dist/vue2-animate.min.css'
import VuxConfig from './public/VuxConfig'

 sync(store, router) // done. Returns an unsync callback fn
Vue.config.productionTip = false
FastClick.attach(document.body);

//import VueJsonp from 'vue-jsonp'

/*
vux工具引入时会导致build打入全部VUX 解决方案1 写入路径  2 在模块中引入 在把模块引入main
import AjaxPlugin  from 'vux/src/plugins/ajax'
import WechatPlugin  from 'vux/src/plugins/wechat'

Vue.use(AjaxPlugin) //Vue.http
Vue.use(WechatPlugin) //Vue.wechat

END*/



//Vue.use(VueJsonp)
Vue.use(VuxConfig)
Vue.use(plugin)
Vue.use(RouterGuide)
//初始化神测
Vue.prototype.$sa.init()
Object.keys(filters).forEach(k => Vue.filter(k, filters[k]) ) // 注册过滤器

/* eslint-disable no-new */
new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app-box')



// WEBPACK FOOTER //
// ./src/main.js